import React, { useState, useEffect } from 'react';
//import { QrScanner } from '@yudiel/react-qr-scanner';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import { MainButton } from '../../components/builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection.js';
import FloatingLayerPublic from '../front/FloatingLayerPublic.js';
import InputWithButton from '../builder/InputWithButton.js';

import Loadable from 'react-loadable';
const QRCamera = Loadable({
	loader:() => import('./QRCamera.js'),
	loading:() => <div>Loading...</div>,
});

export const QrScanInput = (props) => {
	return (
		<QRScan
			{...props}
			type='input'
		/>
	)
};

export const QrScanButton = (props) => {
	return (
		<QRScan
			{...props}
			type='button'
		/>
	)
};


const LayerWrapper = (props) => {
	return (
		<FloatingLayerPublic
			is_builder={props.is_builder}
			enable_behavior={true}
			backButton={props.backButton}
		>
			<div>
				{props.children}

				{(props?.actions ?? false) && (
					<ButtonCollection _class={{ other:'flex_button gui_not_in_top_big gui_flex_col' }}>
						{props.actions}
					</ButtonCollection>
				)}
			</div>
		</FloatingLayerPublic>
	)
};

const QRScan = ({ stage, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	const is_builder = props?.is_builder ?? false;
	const type = props?.type ?? 'button';

	const [ permission_enabled, setPermissionEnabled ] = useState(false);
	const [ allowQRScan, setAllowQRScan ] = useState(false);

	useEffect(() => {
		checkCameraPermission();
	}, []);

	const requestCameraPermission = async(cb) => {
		try {
			await navigator.mediaDevices.getUserMedia({ video:true });
			// Success allowed
			checkCameraPermission(cb);
		} catch(error) {
			// Deny access or error
			console.error("Error on gathering camera permissions.")
		}
	};
	
	const checkCameraPermission = async(cb) => {
		const permissionStatus = await navigator.permissions.query({ name:'camera' });
		setPermissionEnabled(permissionStatus.state == 'granted');

		if(cb != undefined) {
			setTimeout(() => {
				cb();
			}, 500);
		}
	};

	

	return (
		<>
			{(type == 'input') && (
				<InputWithButton
					onSubmit={() => (permission_enabled) ? setAllowQRScan(true) : requestCameraPermission(() => setAllowQRScan(true))}
					submitIcon="knk-qr"
					change={props?.change ?? console.error("empty call")}
					name={props?.name ?? ''}
					value={props?.value ?? ''}
					_class={props._class}
					after_message={(!permission_enabled) ? "To scan, you must allow access to your camera." : null}
					autotranslate={false}
					placeholder={props?.placeholder ?? false}
				>{props?.children ?? i18n("Enter the code")}</InputWithButton>
			)}

			{(type == 'button') && (
				<div>
					<ButtonCollection
						_class={{ other:'flex_button gui_big_button' }}
					>
						<MainButton
							_fullclass=""
							onClick={() => (permission_enabled) ? setAllowQRScan(true) : requestCameraPermission(() => setAllowQRScan(true))}
						>Scan QR code</MainButton>
					</ButtonCollection>

					{(!permission_enabled) && (
						<p class="gui_not_in_top_small">{i18n("To scan, you must allow access to your camera.")}</p>
					)}
				</div>
			)}

			{(allowQRScan && permission_enabled) && (
				<LayerWrapper
					backButton={() => setAllowQRScan(false)}
					is_builder={is_builder}
				>
					<QRCamera
						scan_error={props?.scan_error ?? false}
						scan_success={props?.scan_success ?? false}
						onGetContent={props.onGetContent}
						intl={props.intl}
						type={type}
						autoclose={() => {
							setAllowQRScan(false);
						}}
					/>
				</LayerWrapper>
			)}
		</>
	)
};

export default injectIntl(QRScan);